import React, { useEffect, useRef, useCallback, useMemo, memo } from 'react';
import Modal from '../modal/modal';
import { ImageOuterContainer, ImageInnerContainer, StickyHeaderContainer, StickyFooterContainer, ScrollableContainer, BgPictureContainer, } from './styles';
import { getImageUrl } from './get-image-url';
var customStyles = {
    content: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flexGrow: 1,
        padding: 0,
        border: 'none',
        borderRadius: 'none',
        overflow: 'hidden',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        maxWidth: '100%',
        maxHeight: '100%',
    },
};
var FullScreenModal = function (_a) {
    var images = _a.images, isFullScreenOpen = _a.isFullScreenOpen, setFullScreen = _a.setFullScreen, header = _a.header, footer = _a.footer, setOverlay = _a.setOverlay, setSelectedImage = _a.setSelectedImage, currentIndex = _a.currentIndex;
    var scrollContainerRef = useRef(null);
    var closeModal = useCallback(function () {
        setFullScreen(false);
    }, [setFullScreen]);
    useEffect(function () {
        if (isFullScreenOpen) {
            // Delay the scroll slightly to ensure the modal and images are rendered
            setTimeout(function () {
                if (scrollContainerRef.current) {
                    var targetImage = scrollContainerRef.current.querySelector("[data-image-id=\"full_screen_image_index_" + currentIndex + "\"]");
                    if (targetImage) {
                        targetImage.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                        });
                    }
                }
            }, 0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFullScreenOpen]);
    var handleImageClick = useCallback(function (index) {
        setSelectedImage(index);
        setTimeout(function () { return setOverlay(true); }, 0);
    }, [setSelectedImage, setOverlay]);
    var renderedImages = useMemo(function () {
        return images.map(function (image, index) {
            var smallImage = getImageUrl('small-mobile', image);
            var mediumImage = getImageUrl('medium-mobile', image);
            var largeImage = getImageUrl('large-mobile', image);
            var desktopImage = getImageUrl('desktop', image);
            var wideScreenImage = getImageUrl('wide-screen', image);
            return (React.createElement(ImageInnerContainer, { key: "image_full_screen_" + index, "data-image-id": "full_screen_image_index_" + index, onClick: function () { return handleImageClick(index); } },
                React.createElement(BgPictureContainer, null,
                    !!smallImage && React.createElement("source", { media: "(max-width:320px)", srcSet: smallImage }),
                    !!mediumImage && React.createElement("source", { media: "(max-width:480px)", srcSet: mediumImage }),
                    !!largeImage && React.createElement("source", { media: "(max-width:640px)", srcSet: largeImage }),
                    !!desktopImage && React.createElement("source", { media: "(max-width:1024px)", srcSet: desktopImage }),
                    !!wideScreenImage && React.createElement("img", { loading: "lazy", alt: image.caption, src: wideScreenImage }))));
        });
    }, [images, handleImageClick]);
    return (React.createElement(Modal, { isOpen: isFullScreenOpen, onRequestClose: closeModal, style: customStyles, ariaHideApp: false },
        header && (React.createElement(StickyHeaderContainer, null, header({ onClose: closeModal, activeImageIndex: currentIndex }))),
        React.createElement(ScrollableContainer, { ref: scrollContainerRef },
            React.createElement(ImageOuterContainer, null, renderedImages)),
        footer && (React.createElement(StickyFooterContainer, null, footer({ onClose: closeModal, activeImageIndex: currentIndex })))));
};
export default memo(FullScreenModal);
